import { HostConfig } from 'common/types'

const hostConfig: HostConfig = {
  apiVersion: '/v1',
  protocol: 'https',
  host: (process.env.REACT_APP_HOST && process.env.REACT_APP_HOST.trim()) || 'localhost',
  port: 8080,
  shoppingWebUri: {
    mobile: {
      protocol: 'https',
      host: 'm.shopping.naver.com',
    },
    pc: {
      protocol: 'https',
      host: 'shopping.naver.com',
    },
  },
  smartEditorUri: {
    script: 'https://ssl.pstatic.net/storefarm.editor/static/viewer/common/se_init.min.js?v=',
    style: {
      mobile: 'https://ssl.pstatic.net/storefarm.editor/static/viewer/common/se_viewer_storefarm_mobile.css?v=',
      pc: 'https://ssl.pstatic.net/storefarm.editor/static/viewer/common/se_viewer_storefarm_pc.css?v=',
    },
  },
  customerCouponUri: {
    pc: 'https://benefit.pay.naver.com/coupon',
    mobile: 'https://m.pay.naver.com/b/coupon',
  },
  zzimUri: {
    pc: {
      setStoreZzimUri: 'https://shopping.naver.com/my/p/zzim/channel/add.nhn',
      removeStoreZzimUri: 'https://shopping.naver.com/my/p/zzim/channel/remove.nhn',
      setProductZzim: 'https://shopping.naver.com/my/p/zzim/product/channel/add.nhn',
      removeProductZzim: 'https://shopping.naver.com/my/p/zzim/product/channel/remove.nhn',
      setRelationProductZzim: 'https://shopping.naver.com/my/p/zzim/relation-product/add.nhn',
      removeRelationProductZzim: 'https://shopping.naver.com/my/p/zzim/relation-product/remove.nhn',
    },
    mobile: {
      setStoreZzimUri: 'https://m.shopping.naver.com/my/zzim/channel/add.nhn',
      removeStoreZzimUri: 'https://m.shopping.naver.com/my/zzim/channel/remove.nhn',
      setProductZzim: 'https://m.shopping.naver.com/my/zzim/product/channel/add.nhn',
      removeProductZzim: 'https://m.shopping.naver.com/my/zzim/product/channel/remove.nhn',
      setRelationProductZzim: 'https://m.shopping.naver.com/my/zzim/relation-product/add.nhn',
      removeRelationProductZzim: 'https://m.shopping.naver.com/my/zzim/relation-product/remove.nhn',
    },
    product: 'http://api.cnsv.naver.com/my/zzim/channel/productZzimCacheInfo.nhn', // ?channelProductNos=2000424132&channelProductNos=2000424099&naverIdNo=
    store: 'http://api.cnsv.naver.com/my/keepstore/storeZzimCacheInfo.nhn', // ?naverIdNo=&channelNos=100168746&channelNos=1000021940'
    relationProduct: 'http://api.cnsv.naver.com/my/zzim/channel/relationProductZzimCacheInfo.nhn', // ?naverIdNo=&relatedProductIds=
  },
  windowUri: {
    pc: 'https://swindow.naver.com',
    mobile: 'https://m.swindow.naver.com',
  },
  verticalUri: {
    pc: 'http://pc.shopping2.naver.com',
    mobile: 'http://shopping2.naver.com',
  },
  verticalApiUrl: {
    pc: 'http://api.cnsv.naver.com',
    mobile: 'http://api.cnsv.naver.com',
  },
  naverPayUri: {
    pcOrder: 'https://order.pay.naver.com',
    pc: 'https://pay.naver.com',
    mobile: 'https://m.pay.naver.com',
    benefit: 'https://benefit.pay.naver.com',
  },
  shoppingSearchUri: {
    pc: 'https://search.shopping.naver.com',
    mobile: 'https://msearch.shopping.naver.com',
  },
  shoppingSearchApiUri: {
    pc: 'http://frontapi.shopping.naver.com',
    mobile: 'http://frontapi.shopping.naver.com',
  },
  shoppingMyUri: {
    pc: 'http://pc.shopping2.naver.com/my/p',
    mobile: 'http://shopping2.naver.com/my',
  },
  qrCodeUri: 'http://qrmwig.naver.com/alcatraz_mig/m.jsp',

  giftUri: {
    digitalContents: {
      mediaUri: 'http://dvdapi.navercorp.com',
      bookUri: 'http://nbooks.naver.com',
      ogqmarketUri: 'http://api.storep.naver.com',
      music: 'http://apiapp.music.naver.com/chart/domain/TOTAL/top100/trackChart.json',
      movie:
        'http://dvdapi.nhncorp.com/api/stats/dailyRankingListForGift.json?apiKey=MTlNUT1JFXzIwMTIwMjEzX05TVE9SRQ&limit=10&ymd=2016-01-01&inAdult=Y&dbType=DB1',
      air:
        'http://dvdapi.nhncorp.com/api/stats/dailyRankingListForGift.json?apiKey=MTlNUT1JFXzIwMTIwMjEzX05TVE9SRQ&limit=10&ymd=2016-01-01&inAdult=Y&dbType=DB2',
      book:
        'http://nbooks.naver.com/search/top100.nhn?top100TypeCode=WEEKLY&excludeAdultContents=true&serviceType=EBOOK',
      ogqmarket: 'http://api.storep.naver.com/proxy/search/products/categories/',
    },
    clickLog: 'https://m.shopping.naver.com/common/m/clicklog.nhn',
  },
  trendUri: {
    trendPick: 'http://m.trend.shopping.naver.com/trendpick/index.nhn',
    trendShop: 'http://m.trend.shopping.naver.com/trendshop/index.nhn',
  },
  freeExperienceUrl: {
    pc: 'https://shopping.naver.com/plan2/p/experience.nhn',
    mobile: 'https://m.shopping.naver.com/plan2/m/experience.nhn',
  },
  locationAgreeSessionKey: {
    pc: 'http://nid.naver.com/iasystem/safe_session.nhn',
    mobile: 'http://nid.naver.com/iasystem/mobile_session.nhn',
  },
  locationAgreeUri: {
    pc: 'https://nid.naver.com/iasystem/pop.nhn',
    mobile: 'https://nid.naver.com/iasystem/m_pop.nhn',
  },
  smartStoreUri: {
    pc: 'https://smartstore.naver.com',
    mobile: 'https://m.smartstore.naver.com',
  },
  imageUpload: {
    domain: 'ecommerce.upphoto.naver.com',
    serviceName: 'checkout',
    apiKey: 'd5be2642fc31f90e2eccd136fe7be072',
  },
  videoUpload: {
    popupUri: 'https://uploader.nmv.naver.com/upload/write.nhn',
    script: 'https://sstatic-g.rmcnmv.naver.net/resources/uploader/js/v2/video_uploader_common_min.js',
    serviceId: 22,
    durationLimit: 64800,
    fileSizeLimit: 1073741824,
  },
  imageUrl: {
    domain: 'https://phinf.pstatic.net/checkout.phinf',
  },
  videoUrl: {
    domain: 'https://phinf.pstatic.net/image.nmv',
  },

  pointPlus: {
    pc: 'https://pointplus.pay.naver.com/purchaseDecision/information',
    mobile: 'https://pointplus.pay.naver.com/m/purchaseDecision/information',
  },
  tagPickMainUrl: {
    mobile: 'https://m.naver.com',
  },
  selective: 'https://selective.naver.com',
}

export default hostConfig
